import { jsxs, jsx } from "react/jsx-runtime";
import { FormControlLabel } from "@mui/material";
import FormControl from "@mui/material/FormControl/index.js";
import FormHelperText from "@mui/material/FormHelperText/index.js";
import Paper from "@mui/material/Paper/index.js";
import { paperStyles } from "./selection-control-field.styles.js";
const SelectionControlField = ({
  helperText,
  control,
  label,
  labelAlign,
  labelPlacement,
  ...rest
}) => {
  return /* @__PURE__ */ jsxs(FormControl, { ...rest, children: [
    /* @__PURE__ */ jsx(Paper, { elevation: 0, sx: paperStyles, children: /* @__PURE__ */ jsx(FormControlLabel, { control, label, labelAlign, labelPlacement }) }),
    helperText && /* @__PURE__ */ jsx(FormHelperText, { children: helperText })
  ] });
};
export {
  SelectionControlField
};
